export default {
    setCurrentVideoObject (state, { videoObject }) {
        state.currentVideoObject = videoObject
    },
    setCurrentPromoVideoObject (state, { videoObject }) {
        state.currentPromoVideoObject = videoObject
    },
    setCurrentVideoStatus (state, { videoStatus }) {
        state.currentVideoStatus = videoStatus
    },
    setCurrentVideoTranscript (state, { transcript }) {
        state.currentVideoTranscript = transcript
    },
    setCopiedPlaylistObject (state, { newPlaylist }) {
        state.copiedPlaylistObject = newPlaylist
    },
    setCurrentVideoDurationWatched (state, duration) {
        state.currentVideoDurationWatched = duration
    },
    setOriginalVideoCode (state, videoCode) {
        state.originalVideoCode = videoCode
    },
    setOriginalVideoTitle (state, videoTitle) {
        state.originalVideoTitle = videoTitle
    },
    setVideoSubcategory (state, { subCategories }) {
        state.videoSubCategories = subCategories
    },
    setCorporatePayload (state, { corp }) {
        state.corporatePayload = corp
    },
    setB2BVideos (state, { bVideos }) {
        state.B2BVideos = bVideos
    },
    setB2BTopVideo (state, { bVideos }) {
        state.b2BTopVideo = bVideos
    },
    setTaggedEmailList (state, { eList }) {
        state.taggedEmailList = eList
    },
    setArchivePlaylistObject (state, { eList }) {
        state.archivePlaylistObject = eList
    },
    setItemChangeInPlaylist (state, { item }) {
        state.itemChangeInPlaylist = item
    },
    setServicePodcast (state, { anyThing }) {
        state.servicePodcast = anyThing
    },
    setUserNewPlaylistObject (state, { playlist }) {
        state.userNewPlaylistObject = playlist
    },
    setTrendingNewPlaylistObject (state, { playlist }) {
        state.trendingNewPlaylistObject = playlist
    },
    setCorpNewPlaylistObject (state, { playlist }) {
        state.corpNewPlaylistObject = playlist
    }
}



// WEBPACK FOOTER //
// ./src/store/videoplayer/mutations.js